module.exports = __webpack_public_path__ + "static/media/notes-icon.bd84f9d6.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/notes-icon.svg
// module id = 1030
// module chunks = 0